export const debugSearchResultsName = 'debugSearchResults'
